
import React, { useEffect, useState, forwardRef, useRef } from "react";

import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';
import {
    Box, Button, Grid, Typography,
} from '@mui/material';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import HomeIcon from '@mui/icons-material/Home';
import styles from '../../styles.module.css';
import { NavLink, useLocation } from "react-router-dom";



function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 2 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}


function PaymentsHome() {
    const location = useLocation()
   

    return (
        <>
           
            <Paper style={{ borderRadius: '0px' }}>
                <Box
                    sx={{ overflow: 'auto', whiteSpace: 'nowrap', margin: '10px 10px 20px 10px' }} >
                    {(location.pathname == '/payments/sales/customer-payment') ?
                        <NavLink to='/payments/sales/customer-payment'>
                            <Button className={`${styles.tab_active}`} style={{ borderRadius: '8px 8px 0px 0px' }}>Customer Payment</Button>
                        </NavLink>
                        :
                        <NavLink to='/payments/sales/customer-payment'>
                            <Button className={`${styles.tab}`} style={{ borderRadius: '8px 8px 0px 0px' }}>Customer Payment</Button>
                        </NavLink>
                    }
                    {(location.pathname == '/payments/purchase/supplier-payment') ?
                        <NavLink to='/payments/purchase/supplier-payment'>
                            <Button className={`${styles.tab_active}`} style={{ borderRadius: '8px 8px 0px 0px' }}>Supplier Payment</Button>
                        </NavLink>
                        :
                        <NavLink to='/payments/purchase/supplier-payment'>
                            <Button className={`${styles.tab}`} style={{ borderRadius: '8px 8px 0px 0px' }}>Supplier Payment</Button>
                        </NavLink>
                    }
                </Box>
            </Paper>
        </>
    )
}

export default PaymentsHome;